module.exports = __webpack_public_path__ + "static/media/mozza-dt-2023-fr.43be5402.jpg";